import { ErrorIcon, RefreshIcon } from "./icons";

export default function ErrorState({ message = "Couldn't load this data.", onRetry }) {
  return (
    <div className="error-state">
      <ErrorIcon />
      <div>
        <div className="error-state__title">Something went wrong</div>
        <div className="error-state__desc">{message}</div>
      </div>
      {onRetry && (
        <button type="button" className="btn btn-ghost error-state__retry" onClick={onRetry}>
          <RefreshIcon style={{ width: 14, height: 14, marginRight: 6, verticalAlign: -2 }} />
          Retry
        </button>
      )}
    </div>
  );
}
